import React from 'react';

interface NetworkSelectorProps {
    networks: string[];
    selectedNetwork: string;
    onNetworkChange: (network: string) => void;
    loading?: boolean;
}

const NetworkSelector: React.FC<NetworkSelectorProps> = ({
    networks,
    selectedNetwork,
    onNetworkChange,
    loading = false,
}) => {
    return (
        <div>
            <label htmlFor="networkSelect" className="block text-sm font-semibold text-gray-700 mb-3">
                Network
            </label>
            <div className="relative">
                <select
                    id="networkSelect"
                    value={selectedNetwork}
                    onChange={(e) => onNetworkChange(e.target.value)}
                    disabled={loading}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-500 transition-all duration-200 bg-white appearance-none cursor-pointer hover:border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-50"
                >
                    <option value="">{loading ? 'Loading networks...' : 'Select a network'}</option>
                    {networks.map((network) => (
                        <option key={network} value={network}>
                            {network}
                        </option>
                    ))}
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    {loading ? (
                        <div className="w-5 h-5 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
                    ) : (
                        <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NetworkSelector;